/* eslint-disable @typescript-eslint/naming-convention */
import { injectable } from '@servicetitan/react-ioc';
import { CancelToken } from 'axios';

import { HttpClient } from './http-client';
import { BaseRequestModel } from '../models/base-request.model';

@injectable()
export class BattlecardApi {
    constructor(private readonly httpClient: HttpClient) {
    }

    getBattlecard = async (
        data: GetBattlecardRequestModel,
        cancellationToken?: CancelToken,
    ) => {
        return this.httpClient.post<void, GetBattlecardRequestModel>(
            '/battlecard',
            data,
            {
                cancelToken: cancellationToken,
                timeout: 70000,
            },
        );
    };
}


interface GetBattlecardRequestModel extends BaseRequestModel {
    job_id: number;
    timezone: number;
    location_id?: number;
    equipment_id?: number;
}